var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeacherDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0898 8V19.3807C22.0898 20.2744 21.2418 21 20.1959 21H4.98293C3.93707 21 3.08984 20.2744 3.08984 19.3807V8",
    stroke: "#272B2B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0898 21V14H15.0898V21",
    stroke: "#272B2B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.08984 8L4.81712 3H20.3626L22.0898 8",
    stroke: "#272B2B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.08984 8C9.08984 9.10473 7.74803 10 6.08984 10C4.43275 10 3.08984 9.10473 3.08984 8",
    stroke: "#272B2B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0898 8C16.0898 9.10473 14.5244 10 12.5898 10C10.6566 10 9.08984 9.10473 9.08984 8",
    stroke: "#272B2B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0898 8C22.0898 9.10473 20.748 10 19.0898 10C17.4328 10 16.0898 9.10473 16.0898 8",
    stroke: "#272B2B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeacherDashboardIcon);
export default __webpack_public_path__ + "static/media/teacher-dashboard-icon.8ef58ce27ca37cf7e3cc280662603d19.svg";
export { ForwardRef as ReactComponent };